import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TableMeta } from "../../models/table-meta.interface";
import { TosTableTdComponent } from "../tos-table/tos-table-td/tos-table-td.component";
import { CommonUtils } from "../../utils/common-utils";
import { NoDataComponent } from "../no-data/no-data.component";
import { NzTagComponent } from "ng-zorro-antd/tag";
import { NgIf, NgTemplateOutlet } from "@angular/common";

@Component({
  selector: 'app-view-details',
  standalone: true,
  imports: [
    TosTableTdComponent,
    NoDataComponent,
    NzTagComponent,
    NgIf,
    NgTemplateOutlet
  ],
  templateUrl: './view-details.component.html',
  styleUrl: './view-details.component.scss'
})
export class ViewDetailsComponent {
  @Input() detailsMeta!: TableMeta;
  @Input() detailsData!: any;
  @Input() title: string = 'Items Overview'
  @Input() titleTag?: string = '';
  @Input() showTitle: boolean = true;
  @Input() showNullColumns: boolean = true;

  @Output() rowActionTriggered = new EventEmitter<{ actionName: string; record: any }>();

  protected readonly CommonUtils = CommonUtils;

  shouldShowColumn(column: any): boolean {
    if (this.showNullColumns) {
      return true;
    }

    const value = CommonUtils.getNestedValue(this.detailsData, column.fieldName);
    if (value === null || value === undefined) {
      return false;
    }

    if (typeof value === "string") {
      return value.trim().length > 0;
    }

    if (Array.isArray(value)) {
      return value.length > 0;
    }

    return true;
  }

  handleInlineAction(event: { actionName: string; record: any }) {
    this.rowActionTriggered.emit(event)
  }

  ngOnInit() {
    console.log(" container.forwardingNote: ",  this.detailsMeta);
    console.log(" container.forwardingNote: ",  this.detailsData);
  }
}
